import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-pms-error',
  templateUrl: './pms-error.component.html',
  styleUrl: './pms-error.component.css'
})
export class PmsErrorComponent {

  @Input() errorType: string = 'route';

  // errorType: 'route' | 'hash' | 'unknown' = 'unknown';

  constructor() {}

   goBack(): void {
    window.history.back();
  }
}
